"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerBandung: ReactNode = (
  <>
    <div className="text-xl font-bold mb-2">Bandung Bergerak Cepat, Komputermu Harus Bisa Ikut</div>

    <div className="text-lg font-semibold mb-2">
      Beli Komputer untuk Proyek Singkat? Kadang Justru Nambah Beban.
    </div>

    <p className="mb-4">
      Bayangkan kamu lagi ngerjain tender penting, event besar, atau desain mendadak buat klien. Tapi perangkatmu lemot, atau malah belum ada. Di Bandung, waktu itu bukan cuma uang, tapi reputasi. Nah, di situlah <strong>sewa komputer Bandung</strong> jadi jalan ninja yang diam-diam menyelamatkan banyak kepala dari pusing.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Jangkauan? Jangan Ragukan. Kami Sampai ke Sudut Kota.</div>
        <p className="text-sm">
          Dari gang sempit Antapani sampai event di Lembang, <strong>sewa komputer Bandung</strong> kami bener² menyisir semua titik. Kamu tinggal sebut lokasi, sisanya kami urus. Gak peduli pagi² buta atau hujan deras, kalau unit ready, langsung jalan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Unit Bukan Kaleng², Tapi Spek Tempur</div>
        <p className="text-sm">
          Butuh Intel i7? Ryzen kekinian? RAM 32GB atau SSD ngebut? Semua ada. <strong>Sewa komputer Bandung</strong> dari kami bukan sekadar menyala, tapi ngebut tanpa ngedrop. Presentasi jalan? Editing render lancar? Aman.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Harga Sewa? Bisa Nego, Asal Jelas Kebutuhannya.</div>
        <p className="text-sm">
          Kadang cuma butuh 1 unit buat remote job di cafe Braga. Kadang butuh 80 unit buat pelatihan instansi. Gak usah takut harga. <strong>Sewa komputer Bandung</strong> kami fleksibel: harian, mingguan, bulanan, sampe custom-an.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Kami yang Gerak, Kamu Fokus Kerja.</div>
        <p className="text-sm">
          Kamu gak sempat install software? Atau gak ngerti kabel²? Tenang, teknisi kami ikut antar. <strong>Sewa komputer Bandung</strong> ini bukan cuma antar unit, tapi sampe nyala & siap kerja. Cihampelas, Dago, Pasteur, kami hafal medan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Support 24/7? Ini Bukan Janji, Tapi Prosedur.</div>
        <p className="text-sm">
          Error pas acara? Jangan panik. Kami standby. <strong>Sewa komputer Bandung</strong> ini termasuk layanan darurat. Ganti unit? Kirim. Trouble ringan? Video call bantuin. Nunggu teknisi? Kami push cepat, karena kami ngerti tekanan event.
        </p>
      </li>
    </ul>

    <div className="text-xl font-bold mb-3">Durasi Sewa? Jangan Kaku, Kami Ikut Irama Kamu</div>
    <p className="mb-4">
      3 hari untuk lomba coding, 1 minggu buat workshop digital marketing, atau 6 bulan untuk proyek diskominfo, semua bisa. <strong>Sewa komputer Bandung</strong> dari kami yang adaptif.
    </p>

    <div className="text-xl font-bold mb-3">Perawatan Selama Sewa = Bukan Bonus, Tapi Wajib</div>
    <p className="mb-4">
      Kami percaya: unit bagus bukan yang mahal, tapi yang performanya stabil sampai akhir kontrak. <strong>Sewa komputer Bandung</strong> kami dilengkapi pemeliharaan berkala. Kalau rusak? Ganti langsung. Nunggu? Enggak pakai.
    </p>

    <CTA
      title="Siap Lembur Editing & Olah Data Bosku?"
      description="🚚 Butuh sewa komputer di Bandung sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerBandung;